var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('speed-slider',_vm._b({attrs:{"label":_vm.$t('tts_speed'),"speed":_vm.speed},on:{"speed-changed":_vm.handleSpeedChange}},'speed-slider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }